<!-- App Loading Overlay -->
<div class="app-loading-overlay safe-area-container" *ngIf="loading$ | async">
  <div class="app-loading-content">
    <img src="assets/logo/brand_2026/Logo_Icon_blue_orange_yellow.png" alt="Cleverly" class="loading-logo" />
    <svg width="50" height="50" viewBox="0 0 50 50" class="app-loading-spinner">
      <circle 
        cx="25" 
        cy="25" 
        r="20" 
        fill="none" 
        stroke="var(--p-primary-color)" 
        stroke-width="3" 
        stroke-linecap="round" 
        stroke-dasharray="90, 150" 
        stroke-dashoffset="-35">
      </circle>
    </svg>
  </div>
</div>

<!-- Main App Content with Safe Area -->
<div class="app-container">
  <clv-toast-center></clv-toast-center>
  <router-outlet></router-outlet>
</div>
